'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _types = require('../actions/types');

var _track = require('../actions/track');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$trackers = _ref.trackers,
        trackers = _ref$trackers === undefined ? {} : _ref$trackers,
        onSuccess = _ref.onSuccess,
        onError = _ref.onError;

    return function (_ref2) {
        var dispatch = _ref2.dispatch;
        return function (next) {
            return function (action) {
                var result = next(action);

                if (action.type === _types.TRACKER_SUCCESS) {
                    var _action$payload = action.payload;
                    _action$payload = _action$payload === undefined ? {} : _action$payload;
                    var response = _action$payload.response,
                        params = _action$payload.params,
                        trackerId = _action$payload.trackerId;


                    onSuccess(response, params, trackerId);
                    return _promise2.default.resolve({ response: response, params: params, trackerId: trackerId });
                }

                if (action.type === _types.TRACKER_ERROR) {
                    var _action$payload2 = action.payload;
                    _action$payload2 = _action$payload2 === undefined ? {} : _action$payload2;
                    var error = _action$payload2.error,
                        _params = _action$payload2.params,
                        _trackerId = _action$payload2.trackerId;


                    onError(error, _params, _trackerId);
                    return _promise2.default.resolve({ response: error, params: _params, trackerId: _trackerId });
                }

                if (action.type === _types.TRACKER_START) {
                    var _action$payload3 = action.payload,
                        _params2 = _action$payload3.params,
                        _trackerId2 = _action$payload3.trackerId;
                    var _trackers$_trackerId = trackers[_trackerId2],
                        tracker = _trackers$_trackerId === undefined ? {} : _trackers$_trackerId;


                    if (!tracker.track) {
                        return dispatch((0, _track.trackerError)(new Error('No registered tracker matching ' + _trackerId2), _trackerId2));
                    }

                    return tracker.track(_params2).then(function (_ref3) {
                        var response = _ref3.response;
                        return dispatch((0, _track.trackerSuccess)(response, _params2, _trackerId2));
                    }).catch(function (error) {
                        return dispatch((0, _track.trackerError)(error, _params2, _trackerId2));
                    });
                }

                if (action.type === _types.TRACKER_MULTIPLE_START) {
                    var _action$payload4 = action.payload;
                    _action$payload4 = _action$payload4 === undefined ? {} : _action$payload4;
                    var _action$payload4$trac = _action$payload4.trackerIds,
                        trackerIds = _action$payload4$trac === undefined ? (0, _keys2.default)(trackers) : _action$payload4$trac,
                        _params3 = _action$payload4.params;


                    var trackAll = trackerIds.map(function (trackerId) {
                        return dispatch((0, _track.trackerStart)(_params3, trackerId));
                    });

                    return _promise2.default.all(trackAll).then(function (completed) {
                        var finishedResponses = [];
                        var finishedTrackerIds = [];

                        completed.forEach(function (completedTrack) {
                            finishedResponses.push(completedTrack.response);
                            finishedTrackerIds.push(completedTrack.trackerId);
                        });

                        return dispatch((0, _track.trackerMultipleFinish)(_params3, finishedTrackerIds, finishedResponses));
                    });
                }

                if (action.type === _types.TRACKER_MULTIPLE_FINISH) {
                    var _action$payload5 = action.payload;
                    _action$payload5 = _action$payload5 === undefined ? {} : _action$payload5;
                    var responses = _action$payload5.responses,
                        _params4 = _action$payload5.params,
                        _trackerIds = _action$payload5.trackerIds;

                    return _promise2.default.resolve({ responses: responses, params: _params4, trackerIds: _trackerIds });
                }

                return result;
            };
        };
    };
};
//# sourceMappingURL=tracker.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/redux/middlewares/tracker.js
 ** module id = 562
 ** module chunks = 1
 **/